import type { ISidebarModule } from "@fondationcss/ui";

export const sidebarItems: ISidebarModule[] = [
    {
      roles: [ 'Perspective.TimeLine.Student', 'Perspective.TimeLine.Administrator', 'Perspective.TimeLine.Viewer' ],
      items: [
        { header: 'Parcours' }
      ]
    },
    {
      roles: [ 'Perspective.TimeLine.Student' ],
      items: [
        { title: 'Élève', icon: 'graduation-cap', to: '/parcours/eleve' }
      ]
    },
    {
      roles: [ 'Perspective.TimeLine.Administrator', 'Perspective.TimeLine.Viewer' ],
      items: [
        { title: 'Enseignant', icon: 'chalkboard-user', to: '/parcours/enseignant' }
      ]
    },
    {
      roles: [ 'Perspective.TimeLine.Administrator' ],
      items: [
        { title: 'Planification', icon: 'calendar-days', to: '/parcours/planification' },
        { title: 'Gestion', icon: 'sliders', to: '/parcours/gestion' }
      ]
    },
    {
      module: 'Perspective.TimeLine',
      items: [
        { header: 'Lignes de temps' },
        { title: 'Visualiser', icon: 'bars-staggered', to: '/lignedetemps/visualisateur' }
      ]
    },
    {
      roles: [ 'Perspective.Administrator', 'Perspective.TimeLine.Administrator' ],
      items: [
        { header: 'Cours' },
      ]
    },
    {
      roles: [ 'Perspective.TimeLine.Administrator' ],
      items: [
        { title: 'Gérer', icon: 'users-gear', to: '/lignedetemps/parametres2' },
      ]
    },
    {
      roles: [ 'Perspective.Administrator' ],
      items: [
        { title: 'Importer/Exporter', icon: 'download', to: '/admin/import-export' }
      ]
    },
    {
      roles: [ 'Core.Calendar.Administrator' ],
      items: [
        { header: 'Administration' },
        { title: 'Calendrier', icon: 'calendar', to: '/core/calendar/system' }
      ]
    }
  ];
  